import React from 'react';
import { Card } from 'primereact/card';
import DescriptionBox from '../../../../components/descriptionBox/DescriptionBox';
import { CoachingTabs } from '../../../../utils/typeConstants';

interface UnderstandSectionProps {
    understandNotes: string;
    onUnderstandNotesChange: (value: string) => void;
}

export const UnderstandSection: React.FC<UnderstandSectionProps> = ({
    understandNotes,
    onUnderstandNotesChange
}) => {
    const questionCategories = [
        {
            title: 'Current Situation',
            color: '#c0bef480',
            questions: [
                '"Can you walk me through what\'s been happening recently?"',
                '"What does a typical day look like for you right now?"',
                '"How do you feel about your current progress?"'
            ]
        },
        {
            title: 'Goals & Motivation',
            color: '#FCE4EC',
            questions: [
                '"What is most important to you right now?"',
                '"What would success look like for you in this situation?"',
                '"Why is this goal meaningful to you?"'
            ]
        },
        {
            title: 'Strengths and Positives',
            color: '#E1F5FE',
            questions: [
                '"What has been working well for you?"',
                '"What are you proud of lately?"',
                `"What are some successes you've had since our last session?"`
            ]
        },
        {
            title: 'Reflection and Changes',
            color: '#FFF3E0',
            questions: [
                '"What would you do differently if you could go back?"',
                '"What have you learned from this experience?"',
                '"What options do you see moving forwards?"'
            ]
        },
        {
            title: 'Exploring Challenges and Obstacles',
            color: '#d8f9caff',
            questions: [
                '"What challenges have you faced recently?"',
                '"What is getting in the way of your goals?"',
                `"Can you describe a time when things didn't go as planned?"`
            ]
        },
        {
            title: 'Deepening the Conversation',
            color: '#E8F5E9',
            questions: [
                '"Can you tell me more about that?"',
                '"How did that make you feel?"'
            ]
        }
    ];

    return (
        <div className="fuel-section-content">
            <h4 className="section-title">Understand the Current State</h4>
            <p className="section-subtitle">
                Ask open-ended questions to discover the associate&apos;s situation. What is working well,
                what challenges the associate is facing. During this phase, try to identify any
                weakness or obstacles the associate is facing as well.
            </p>

            <div className="question-categories-grid">
                {questionCategories.map((category, index) => (
                    <Card
                        key={index}
                        className="question-category-card"
                        style={{ backgroundColor: category.color }}
                    >
                        <h5>{category.title}</h5>
                        <ul className="category-questions">
                            {category.questions.map((q, qIndex) => (
                                <li key={qIndex}>{q}</li>
                            ))}
                        </ul>
                    </Card>
                ))}
            </div>

            <div className="notes-section">
                <DescriptionBox
                    title='Understanding Notes'
                    responseDescription={understandNotes}
                    value={understandNotes}
                    limit={4000}
                    onChange={(val: string) => onUnderstandNotesChange(val)}
                    via={CoachingTabs.CoachingActionPlan}
                />
            </div>
        </div>
    );
};
